// extracted by mini-css-extract-plugin
export default {"details":"details__gRGlr","content":"content__BZ99i","icon":"icon__L_i9H"};